<script lang="ts">
  import { Dialog } from 'bits-ui'
  import { X } from '@lucide/svelte'
  import { siteDialogContentClass, siteDialogOverlayClass } from '~/app/site-theme'
  import { cn } from '~/lib/utils'
  import type { Snippet } from 'svelte'

  interface Props {
    open?: boolean
    title?: string
    description?: string
    wide?: boolean
    class?: string
    children: Snippet
    footer?: Snippet
  }

  let {
    open = $bindable(false),
    title,
    description,
    wide = false,
    class: className,
    children,
    footer,
  }: Props = $props()
</script>

<Dialog.Root bind:open>
  <Dialog.Portal>
    <Dialog.Overlay class={siteDialogOverlayClass} />
    <Dialog.Content class={cn(siteDialogContentClass, wide && 'max-w-4xl', className)}>
      <!-- Шапка и крестик вне скролла -->
      <div class="flex shrink-0 items-start justify-between gap-4 border-b border-[rgba(122,181,71,0.12)] p-5 sm:p-6 sm:pb-4">
        <div class="min-w-0 space-y-1 pr-2">
          {#if title}
            <Dialog.Title class="text-xl font-bold text-white">{title}</Dialog.Title>
          {/if}
          {#if description}
            <Dialog.Description class="text-sm text-[#dfe8d8]">{description}</Dialog.Description>
          {/if}
        </div>
        <Dialog.Close
          class="shrink-0 rounded-lg p-2 text-[#dfe8d8] transition-colors hover:bg-[#7AB547]/10 hover:text-white"
          aria-label="Закрыть"
        >
          <X class="size-5" />
        </Dialog.Close>
      </div>

      <div class="min-h-0 flex-1 overflow-y-auto p-5 pt-4 sm:p-6 sm:pt-4">
        {@render children()}
      </div>

      {#if footer}
        <div
          class="flex shrink-0 flex-wrap items-center justify-end gap-3 border-t border-[rgba(122,181,71,0.12)] p-5 sm:p-6 sm:pt-4"
        >
          {@render footer()}
        </div>
      {/if}
    </Dialog.Content>
  </Dialog.Portal>
</Dialog.Root>
